import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "goatsteakmeat";

function GIGoatSteakMeat() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIGoatSteakMeat;